import { artWorks } from "../data/data";

export function getArtWorkById(idSearch: string) {
  return artWorks.find(({ id }) => {
    return id === idSearch;
  });
}
